import { MaskedLine, Reveal } from "../components/motion";

const Ownership = () => (
  <section
    id="ownership"
    data-testid="ownership-section"
    className="relative bg-[#08162B] text-white py-32 lg:py-48 overflow-hidden"
  >
    <div className="absolute inset-0 hero-grid pointer-events-none" />
    <div className="relative max-w-5xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="font-mono text-[11px] sm:text-xs uppercase tracking-[0.35em] text-[#D4AF37]">
          The Bigger Idea
        </p>
      </Reveal>

      <h2 className="mt-10 font-display tracking-[0.02em] leading-[1.02] text-[clamp(2.4rem,6.5vw,5.5rem)]">
        <MaskedLine delay={0.1}>ECOMMERCE IS THE VEHICLE.</MaskedLine>
        <MaskedLine delay={0.28} className="text-white/35">
          OWNERSHIP IS THE DESTINATION.
        </MaskedLine>
      </h2>

      <div className="mt-16 max-w-2xl space-y-6">
        <Reveal delay={0.1}>
          <p className="text-lg sm:text-xl leading-relaxed text-white/60">
            The real opportunity isn't simply learning how to make money online. It's learning how
            to create value — and own the thing producing that value.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="text-lg sm:text-xl leading-relaxed text-white/60">
            Most people spend their lives asking:
          </p>
        </Reveal>
      </div>

      <div className="mt-12 space-y-8">
        <Reveal delay={0.15}>
          <p className="font-condensed font-light text-2xl sm:text-4xl text-white/40">
            "How much will someone pay me?"
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="font-condensed text-2xl sm:text-4xl text-white">
            "How much value can I create?"
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.35} className="mt-14">
        <p className="font-mono text-[11px] sm:text-xs uppercase tracking-[0.25em] text-white/40">
          Entrepreneurship teaches you to ask the second question.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Ownership;
